export const IMAGE_GENERATION_MODELS = {
  'sd-1.5': 'Stable Diffusion 1.5'
} as const;

export const SCHEDULERS = {
    'DDIM': 'Steady Eddie - Slow & Reliable (DDIM)',
    'K_EULER': 'Simple Sally - Quick & Basic (Euler)',
    'K_EULER_ANCESTRAL': 'Wild Child - Creative & Chaotic (Euler Ancestral)',
    'PNDM': 'Old Timer - Classic Method (PNDM)',
    'KLMS': 'Middle Road - Balanced Choice (KLMS)',
    'DPMSolverMultistep': 'Fast & Furious (DPMSolverMultistep)'
} as const;

export const PARAMETERS = {
  guidanceScale: {
    label: 'Creativity Mode',
    min: 1,
    max: 20,
    step: 1,
    default: 7.5,
    descriptions: {
      1: 'Zen Mode 🧘‍♂️',
      5: 'Coffee Break ☕',
      10: 'Beer Time 🍺',
      15: 'Wine Night 🍷',
      20: 'Party Mode 🍾'
    }
  },
  inferenceSteps: {
    label: 'Attention to Detail',
    min: 20,
    max: 150,
    step: 10,
    default: 50,
    descriptions: {
      20: 'Quick Sketch 🏃‍♂️',
      50: 'Balanced 🎨',
      100: 'Perfectionist 🔍',
      150: 'Obsessive 🧐'
    }
  },
  seed: {
    label: 'Magic Number',
    min: -1,
    max: 2147483647,
    default: -1,
    description: '-1 for random magic ✨'
  }
} as const; 